export default __webpack_public_path__ + "static/media/static-banner.ac85cdde.png";